import { SET_TEMPLATES, SET_CUSTOM_TEMPLATES } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').Templates} Templates
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @type {Templates}
 */
const INITIAL_STATE = {
  templates: {},
  customTemplates: [],
}

/**
 * @param {Templates} state
 * @param {PltrAction} action
 * @return {Templates}
 */
const templatesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_TEMPLATES: {
      return {
        ...state,
        templates: action.templates,
      }
    }
    case SET_CUSTOM_TEMPLATES: {
      return {
        ...state,
        customTemplates: action.customTemplates,
      }
    }
    default: {
      return state
    }
  }
}

export default templatesReducer
